module.exports = __webpack_public_path__ + "img/ic_flash.89533d18.svg";